/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterTodos(filtro) {
        let url = `${api}/fornecedor/pagamentos?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportarPagamentos(exportacao) {
        let url = `${api}/fornecedor/pagamentos/exportar?dataInicial=${exportacao.dataInicial}
        &dataFinal=${exportacao.dataFinal}&status=${exportacao.status}&tipo=${exportacao.tipo}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprovante(reciboDto) {
        let url = `${api}/fornecedor/pagamentos/comprovante?id=${reciboDto.id}&comprovante=${reciboDto.comprovante}`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
